import React, { HTMLProps, ReactNode } from 'react';
import styles from './SourceName.module.scss';
import Typography from '@mui/material/Typography';
import DataSetIcon from 'js/components/sidebar/icons/DataSetIcon';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';

interface SourceNameProps {
  type: 'nexset' | 'source';
  icon?: string;
  name?: string;
  title?: string;
  description?: string | ReactNode;
  chipTitle?: string | ReactNode;
  id?: string;
}

export function SourceName(props: SourceNameProps & HTMLProps<HTMLDivElement>) {
  const { type, icon, name, chipTitle = 'ID', description, title, id, ...rest } = props;
  return (
    <div className={styles.container} {...rest}>
      {(type === 'nexset' || icon) && (
        <div className={styles.icon_container} title={title}>
          {type === 'nexset' ? (
            <DataSetIcon />
          ) : (
            <img title={props.title} className={styles.icon} src={icon} />
          )}
        </div>
      )}

      <div className={styles.content}>
        {!!name ? <Typography variant="body2">{name}</Typography> : null}

        {!!description ? <Typography variant="body3">{description}</Typography> : null}

        {id ? (
          <div>
            <ChipWithCopy toCopy={id}>
              {chipTitle} {id}
            </ChipWithCopy>
          </div>
        ) : null}
      </div>
    </div>
  );
}
